import React, {useState} from 'react';
import {
    Flex,
    Text,
    Button,
    AIStarIcon,
    DropdownV2,
    PriorityIcon
} from '@priority-software/priority-style-react';
import cx from 'classnames';
import styles from './styles.module.scss';
import texts from '../../texts';
import {reportGeneratorsStore} from '../../stores/ReportGeneratorsStore';
import {monitorTransactionValues, ReportType, predictionModuleId} from '../../consts';
import {isModuleExists} from '../../../License/store';
import {sendAnalyticsMonitor} from '../../../../utils/monitoring';

type Props = {
    toggleNewReportDlg: (isopen: boolean, isUsePredictiveModel?: boolean) => void;
};

type MenuItem = {
    item: {label: string; value: ReportType};
    onSelect: (value: ReportType) => void;
};

const getOptions = () => {
    return [
        {
            label: texts.addNewReport,
            value: ReportType.regular
        },
        {
            label: texts.newReportPredictive,
            value: ReportType.predictiveModel
        }
    ];
};

const renderItemContent = ({item, onSelect}: MenuItem) => {
    const {label, value} = item;
    return (
        <Flex componentClasses={styles.menuItem} onClick={() => onSelect(value)} key={value}>
            <Text skin="paragraph-2">{label}</Text>
            {value === ReportType.predictiveModel && <AIStarIcon />}
        </Flex>
    );
};

export const AddNewReportBtn = ({toggleNewReportDlg}: Props) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const hasLicense = isModuleExists(predictionModuleId);

    const onSelect = (value: ReportType) => {
        const isUsePredictiveModel = value === ReportType.predictiveModel;
        const {currentScreen} = reportGeneratorsStore;
        currentScreen?.setIsPredictiveModel(isUsePredictiveModel);
        setIsOpen(false);
        toggleNewReportDlg(true);
    };

    return (
        <Flex componentClasses={styles.multiBtnWrapper} justifyContent="flex-start">
            <Button
                autoFocus
                prefixIcon={hasLicense ? null : PriorityIcon.addSmall}
                onClick={() => {
                    onSelect(ReportType.regular);
                    sendAnalyticsMonitor(monitorTransactionValues.AnalyticsMainNew);
                }}
                componentClasses={cx({[styles.multiButtonMain]: hasLicense})}
            >
                {texts.newReport}
            </Button>
            {hasLicense && (
                <DropdownV2
                    isOpen={isOpen}
                    contentComponentClasses={styles.dropdownContent}
                    trigger={
                        <Button
                            icon={PriorityIcon.arrowBottom}
                            componentClasses={styles.triggerButton}
                            onClick={() => setIsOpen(!isOpen)}
                        />
                    }
                >
                    {getOptions().map(item => renderItemContent({item, onSelect}))}
                </DropdownV2>
            )}
        </Flex>
    );
};
